import { Colors } from '@vetahealth/fishing-gear/colors'
import { View } from 'react-native'
import styled from 'styled-components/native'
import { Icon } from '../Icon'
import { Pressable } from '../Pressable'
import { ErrorText } from '../Text'
import { Label, LabelWrapper, Toggle, ToggleWrapper } from './styles'
import { CheckboxProps } from './types'

const Wrapper = styled.View<{ isChecked?: boolean; isDisabled?: boolean }>`
  align-self: flex-start;
  flex-direction: row;
  padding: 10px 25px 10px 15px;
  background-color: ${({ theme, isChecked }) => (isChecked ? theme.colors.primaryButtonBackground : theme.colors.tertiaryBackground)};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  ${({ isDisabled }) => !isDisabled && 'cursor: pointer;'}
  gap: 10px;
`
const CheckBoxWrapper = styled(ToggleWrapper)<{ isChecked?: boolean; isDisabled: boolean }>`
  background-color: ${({ theme, isChecked }) => (isChecked ? theme.colors.primary : 'transparent')};
`
const CheckBoxElement = styled(Toggle)`
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
  justify-content: center;
  align-items: center;
`
const ErrorWrapper = styled.View``

export function Checkbox({ onChange, isChecked, label, isDisabled = false, error }: CheckboxProps) {
  return (
    <Pressable
      aria-label="checkbox-input"
      onPress={() => onChange(!isChecked)}
      isDisabled={isDisabled}
      render={({ hovered }) => (
        <Wrapper isChecked={isChecked} isDisabled={isDisabled}>
          <View>
            <CheckBoxWrapper isChecked={isChecked} isDisabled={isDisabled} isHovered={hovered && !isDisabled}>
              <CheckBoxElement isChecked={isChecked} isDisabled={isDisabled}>
                {isChecked && <Icon color={Colors.white} icon={['fas', 'check']} size={11} />}
              </CheckBoxElement>
            </CheckBoxWrapper>
          </View>
          <LabelWrapper>
            <Label>{label}</Label>
            {error && (
              <ErrorWrapper>
                <ErrorText>{error}</ErrorText>
              </ErrorWrapper>
            )}
          </LabelWrapper>
        </Wrapper>
      )}
    />
  )
}
